import React, { Fragment, useEffect, useState } from "react";

const Accordion = ({ content, headers, activeIndex, setActiveIndex }: any) => {
    const [active, setActive] = useState<{ [key: number]: boolean }>({});
    const handleActive = (i: any) => {
        setActive({ ...active, [i]: !active[i] });
    };

    useEffect(() => {
        let activeList: any = {};
        headers.forEach((elem: any, index: number) => {
            activeList[index] = false;
        });
        setActive(activeList);
    }, [headers]);

    useEffect(() => {
        if (activeIndex && !isNaN(activeIndex)) {
            if (activeIndex === 8) {
                setActive({ ...active, [activeIndex]: true });
            }
            if (activeIndex === 7) {
                setActive({ ...active, [activeIndex]: true });
            }
        }
    }, [activeIndex]);

    return Array.isArray(content)
        ? headers.map((v: any, i: any) => {
              return (
                  <Fragment key={i}>
                      <div className={`data-grid ${i < headers.length - 1 ? "has-lines" : ""} ${active[i] ? "expand-credit-lock" : "collapse-credit-lock"}`}>
                          <div className="row box" style={{ padding: "0px" }}>
                              <div className="col-xs-10 col-sm-10 pointer" style={{ paddingTop: "15px" }} onClick={() => handleActive(i)}>
                                  <div
                                      className="box-header"
                                      style={{
                                          display: "flex",
                                          alignItems: "center",
                                      }}
                                  >
                                      <div className="box-title-container" style={{ marginBottom: 0 }}>
                                          <div className="box-title-text">
                                              <h4 className="box-title">{v}</h4>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                              <div className="col-xs-2 col-sm-2 flex-end pointer" style={{ paddingTop: 15 }} onClick={() => handleActive(i)}>
                                  <span className="fs-1-5">
                                      <em
                                          className="las la-angle-down"
                                          style={{
                                              transform: active[i] ? "rotate(180deg)" : "",
                                          }}
                                      ></em>
                                  </span>
                              </div>
                              {active[i] ? content[i] : null}
                          </div>
                      </div>
                  </Fragment>
              );
          })
        : null;
};

export default Accordion;
